var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShare = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2987_17532)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.35397 8.25286C2.71031 8.25286 1.37786 9.58531 1.37786 11.229C1.37786 12.8726 2.71031 14.2051 4.35397 14.2051C5.99763 14.2051 7.33008 12.8726 7.33008 11.229C7.33008 9.58531 5.99763 8.25286 4.35397 8.25286ZM0.455078 11.229C0.455078 9.07567 2.20067 7.33008 4.35397 7.33008C6.50726 7.33008 8.25286 9.07567 8.25286 11.229C8.25286 13.3823 6.50726 15.1279 4.35397 15.1279C2.20067 15.1279 0.455078 13.3823 0.455078 11.229Z",
    fill: "#B41730"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.646 1.37786C16.0023 1.37786 14.6698 2.71031 14.6698 4.35397C14.6698 5.99763 16.0023 7.33008 17.646 7.33008C19.2896 7.33008 20.6221 5.99763 20.6221 4.35397C20.6221 2.71031 19.2896 1.37786 17.646 1.37786ZM13.7471 4.35397C13.7471 2.20067 15.4927 0.455078 17.646 0.455078C19.7993 0.455078 21.5448 2.20067 21.5448 4.35397C21.5448 6.50726 19.7993 8.25286 17.646 8.25286C15.4927 8.25286 13.7471 6.50726 13.7471 4.35397Z",
    fill: "#B41730"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.646 15.1279C16.0023 15.1279 14.6698 16.4603 14.6698 18.104C14.6698 19.7476 16.0023 21.0801 17.646 21.0801C19.2896 21.0801 20.6221 19.7476 20.6221 18.104C20.6221 16.4603 19.2896 15.1279 17.646 15.1279ZM13.7471 18.104C13.7471 15.9507 15.4927 14.2051 17.646 14.2051C19.7993 14.2051 21.5448 15.9507 21.5448 18.104C21.5448 20.2573 19.7993 22.0029 17.646 22.0029C15.4927 22.0029 13.7471 20.2573 13.7471 18.104Z",
    fill: "#B41730"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8212 6.39385L7.58527 10.009L7.17285 9.18346L14.4088 5.56836L14.8212 6.39385Z",
    fill: "#B41730"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.58527 12.4492L14.8212 16.0643L14.4088 16.8898L7.17285 13.2747L7.58527 12.4492Z",
    fill: "#B41730"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2987_17532"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShare);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/share.23056795d798fa338da66181bfe1203d.svg";